module.exports = __webpack_public_path__ + "static/media/Dark-analytics-bro.83f893fb.svg";